/**
 * ID Generation Utilities
 * 
 * Optimized utilities for generating various types of IDs
 * used throughout the application.
 */

/**
 * Generate a simple numerical ID
 * @param length - Length of the ID (default: 10)
 * @returns A numerical ID string
 */
export function generateNumericId(length: number = 10): string {
  // Use a more performant approach for ID generation
  const digits = '0123456789';
  let result = '';
  
  // Ensure first digit is not 0 for better ID readability
  result += digits.charAt(Math.floor(Math.random() * 9) + 1);
  
  // Generate remaining digits
  for (let i = 1; i < length; i++) {
    result += digits.charAt(Math.floor(Math.random() * 10));
  }
  
  return result;
}

/**
 * Generate a prefixed numerical ID
 * @param prefix - Prefix for the ID (e.g., 'user_', 'org_')
 * @param length - Length of the numerical part (default: 10)
 * @returns A prefixed numerical ID string
 */
export function generatePrefixedId(prefix: string, length: number = 10): string {
  return `${prefix}${generateNumericId(length)}`;
}

/**
 * Generate a timestamp-based ID
 * @param prefix - Optional prefix for the ID
 * @returns A timestamp-based ID string
 */
export function generateTimestampId(prefix?: string): string {
  const timestamp = Date.now().toString();
  const random = generateNumericId(4);
  return prefix ? `${prefix}${timestamp}_${random}` : `${timestamp}_${random}`;
} 